const YOUTUBE_ID_PATTERN = /^[a-zA-Z0-9_-]{11}$/;

export const extractYoutubeId = (value) => {
  const input = String(value || '').trim();
  if (!input) return null;
  const iframeMatch = input.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  const source = iframeMatch?.[1] || input;
  try {
    const url = new URL(source);
    const hostname = url.hostname.toLowerCase().replace(/^www\./, '');
    let videoId = '';
    if (hostname === 'youtu.be') {
      videoId = url.pathname.slice(1).split('/')[0];
    } else if (
      hostname === 'youtube.com' ||
      hostname === 'm.youtube.com' ||
      hostname === 'music.youtube.com' ||
      hostname === 'youtube-nocookie.com'
    ) {
      if (url.pathname === '/watch') {
        videoId = url.searchParams.get('v') || '';
      } else {
        videoId = url.pathname.match(/^\/(?:embed|shorts|live|v)\/([^/?#]+)/)?.[1] || '';
      }
    }
    return YOUTUBE_ID_PATTERN.test(videoId) ? videoId : null;
  } catch {
    return null;
  }
};

export const generateEmbedCode = (videoId, title = 'YouTube Video') => {
  if (!YOUTUBE_ID_PATTERN.test(String(videoId || ''))) return '';
  const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
  embedUrl.searchParams.set('rel', '0');
  embedUrl.searchParams.set('playsinline', '1');
  embedUrl.searchParams.set('origin', window.location.origin);
  const safeTitle = String(title).replaceAll('&', '&amp;').replaceAll('"', '&quot;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
  return `<iframe width="560" height="315" src="${embedUrl.toString().replaceAll('&', '&amp;')}" title="${safeTitle}" frameborder="0" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;web-share" referrerpolicy="origin-when-cross-origin" allowfullscreen></iframe>`;
};

export const getYoutubePlayerUrl = (youtubeUrl, title) => {
  const videoId = extractYoutubeId(youtubeUrl);
  if (!videoId) return null;
  const query = new URLSearchParams({video: videoId, title: title || 'YouTube Video'});
  return new URL(`/youtube-player.html?${query.toString()}`, window.location.origin).toString();
};

export const openYoutubePlayerPage = (youtubeUrl, title) => {
  const playerUrl = getYoutubePlayerUrl(youtubeUrl, title);
  if (!playerUrl) return false;
  const newTab = window.open(playerUrl, '_blank');
  if (newTab) newTab.opener = null;
  return newTab !== null;
};